module.exports = __webpack_public_path__ + "981f7a29c6911b79b69eff847c1bd54e.png";